// extracted by mini-css-extract-plugin
export default {"app-block":"BookForm_app-block__DX7x6","book-form":"BookForm_book-form__OVKLw","spinner":"BookForm_spinner__Zi3ym"};